export class RBCheck {
  public static isNullOrEmpty(value: any):boolean {
    if (value == null) {
      return true;
    }
    return value === "";
   }

    public static isNullOrHasNoValues(list: any[]):boolean{
      if (list == undefined){
        return true;
      }
      return list.length == 0;
    }
}
